export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8120.ea89d566.jpg";